import { type Enum } from '../../utils/enums'

export const APApprovalChainTypes = {
  BILL_APPROVAL: 0,
  PAYMENT_APPROVAL: 1,
} as const

export type APApprovalChainType = Enum<typeof APApprovalChainTypes>
